import { render } from "./AddLocation.vue?vue&type=template&id=37dfcf71&ts=true"
import script from "./AddLocation.vue?vue&type=script&lang=ts"
export * from "./AddLocation.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/weather-widget-vue/weather-widget-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__